export enum AlertType {
  NONE = 'NONE',
  WARNING = 'WARNING',
  CRITICAL = 'CRITICAL'
}

export enum AlertMessage {
  LIMIT_REACHED = 'Call limit reached on few numbers',
  LIMIT_ABOUT_TO_REACH = 'Call limit about to reach on few numbers'
}
